import React, { useState } from "react";
import back from "../../../assets/back.png";
import { useNationalLeagueStore } from "../../../store/StoreContext";
import { BottomSheet } from "../../../components/bottomSheet/BottomSheet";
import { TCText } from "../../../components/tcText/TCText";
import { AirDatepickerReact } from "../../../components/airDatePicker/AirDatePicker";
import { LeagueLevelsRadioGroup } from "./LeagueLevelsRadioGroup";
import { Colors } from "../../../utils/colors";
import { CreateLeagueBottomSheetBottomView } from "./CreateLeagueSheetBottomView";
import { Button } from "../../../components/button/Button";
import { formatDateToYYYYMMDD } from "../../../utils/utils";

type props = {
  showBottomSheet: boolean;
  closeBottomSheet: () => void;
};

export const CreateLeagueBottomSheet: React.FC<props> = ({
  showBottomSheet,
  closeBottomSheet,
}) => {
  const nationalLeagueStore = useNationalLeagueStore();
  const [selectedStartDate, setSelectedStartDate] = useState<Date | undefined>(
    undefined
  );
  const [selectedEndDate, setSelectedEndDate] = useState<Date | undefined>(
    undefined
  );

  const [startDateVisible, setStartDateVisible] = useState<boolean>(false);
  const [endDateVisible, setEndDateVisible] = useState<boolean>(false);

  const onClose = () => {
    setSelectedStartDate(undefined);
    setSelectedEndDate(undefined);
    setStartDateVisible(false);
    setEndDateVisible(false);
    closeBottomSheet();
  };

  return (
    <BottomSheet isVisible={showBottomSheet} onClose={() => onClose()}>
      <div
        style={{
          height: "95vh",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
        }}>
        <div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}>
            <div
              onClick={() => {
                onClose();
              }}
              style={{ cursor: "pointer" }}>
              <img src={back} alt="back" width={11} height={18} />
            </div>
            <TCText
              style={{
                fontWeight: 600,
                fontSize: 16,
                flex: 1,
                alignSelf: "center",
                textAlign: "center",
              }}
              value="Create League"
            />
          </div>
          <Button
            text={
              selectedStartDate
                ? `Start date:  ${formatDateToYYYYMMDD(selectedStartDate)}`
                : "Select start date"
            }
            onPress={async () => {
              setStartDateVisible(true);
              setEndDateVisible(false);
            }}
            btnStyle={{
              paddingLeft: 40,
              paddingRight: 40,
              height: 50,
              backgroundColor: startDateVisible
                ? Colors.gold
                : Colors.darkBrown,
              width: "100%",
              marginTop: 20,
              marginBottom: 30,
            }}
            textStyle={{
              color: "white",
              fontWeight: 600,
              fontSize: 14,
            }}
          />
          {startDateVisible ? (
            <div className="airDatePicker-container">
              <div className="airDatePicker-inner-container ">
                <AirDatepickerReact
                  startDate={new Date()}
                  // endDate={coachAvailabilityWeekRanges.currentWeekEnd}
                  isThisWeek={true}
                  // preSelectedDates={currentWeekScheduledDates}
                  // viewDate={coachAvailabilityWeekRanges.currentWeekStart}
                  onSelectDate={(date, formattedDate) => {
                    //   setSelectedDate(formattedDate as string);
                    setSelectedStartDate(date as Date);
                    nationalLeagueStore.setStartDate(formattedDate as string);
                    if (selectedEndDate) {
                      setSelectedEndDate(undefined);
                    }
                  }}
                  handleOnAllAvailableSelected={async () => {}}
                  handleOnAllNotAvailableSelected={async () => {}}
                  chosenDate={
                    selectedStartDate
                      ? selectedStartDate.toISOString()
                      : undefined
                  }
                />
              </div>
            </div>
          ) : null}
          <Button
            text={
              selectedEndDate
                ? `End date:  ${formatDateToYYYYMMDD(selectedEndDate)}`
                : "Select end date"
            }
            onPress={async () => {
              setStartDateVisible(false);
              setEndDateVisible(true);
            }}
            btnStyle={{
              paddingLeft: 40,
              paddingRight: 40,
              height: 50,
              backgroundColor: endDateVisible ? Colors.gold : Colors.darkBrown,
              width: "100%",
              marginTop: 20,
              marginBottom: 30,
            }}
            textStyle={{
              color: "white",
              fontWeight: 600,
              fontSize: 14,
            }}
          />
          {endDateVisible ? (
            <div className="airDatePicker-container">
              <div className="airDatePicker-inner-container ">
                <AirDatepickerReact
                  startDate={selectedStartDate ?? new Date()}
                  // endDate={coachAvailabilityWeekRanges.currentWeekEnd}
                  isThisWeek={true}
                  // preSelectedDates={currentWeekScheduledDates}
                  // viewDate={coachAvailabilityWeekRanges.currentWeekStart}
                  onSelectDate={(date, formattedDate) => {
                    //   setSelectedDate(formattedDate as string);
                    setSelectedEndDate(date as Date);
                    nationalLeagueStore.setEndDate(formattedDate as string);
                  }}
                  isResetDate={selectedEndDate === undefined}
                  handleOnAllAvailableSelected={async () => {}}
                  handleOnAllNotAvailableSelected={async () => {}}
                  chosenDate={
                    selectedEndDate ? selectedEndDate.toISOString() : undefined
                  }
                />
              </div>
            </div>
          ) : null}
          <LeagueLevelsRadioGroup />
          <CreateLeagueBottomSheetBottomView
            isDisabled={!selectedStartDate || !selectedEndDate}
            onClose={onClose}
          />
        </div>
      </div>
    </BottomSheet>
  );
};
